import { Injectable, signal } from '@angular/core';

import { AnchoredPopupState } from '@shared/services/anchored-popup/anchored-popup-state';

/** Data describing which reference popover is open. */
export interface ReferencePopupData {
  uid: string;
  targetEntityType: string;
  column: string;
  row: unknown;
}

/** Root singleton: one reference popover open at a time, app-wide. */
@Injectable({ providedIn: 'root' })
export class ReferencePopupService extends AnchoredPopupState<ReferencePopupData> {
  private readonly _pageOutlets = signal(0);
  /** Page-scoped outlets currently mounted; a shell outlet defers to them. */
  readonly pageOutlets = this._pageOutlets.asReadonly();

  registerPageOutlet(): () => void {
    this._pageOutlets.update((n) => n + 1);
    return () => this._pageOutlets.update((n) => n - 1);
  }
}
